import { createRoot } from "react-dom/client";
import { PostHogProvider } from "posthog-js/react";
import Gleap from "gleap";
import { ClerkProvider } from "@clerk/clerk-react";
import App from "./App.tsx";
import "./index.css";
import { getCurrentClerkPublishableKey } from "@/config/deployments";

const publishableKey = getCurrentClerkPublishableKey();

Gleap.initialize("ZX7MW127dRzTpv6kf8jGT7Ok8YyxcZhW");

// Style Gleap widget for bottom-right position
const styleGleapWidget = () => {
  const style = document.createElement('style');
  style.id = 'gleap-custom-style';
  style.innerHTML = `
    /* Position Gleap feedback button at bottom-right */
    .bb-feedback-button,
    .bb-feedback-button--bottomleft {
      right: 20px !important;
      left: auto !important;
      bottom: 20px !important;
    }
    
    /* Position Gleap chat window at bottom-right */
    div[class*="gleap"] > div[class*="gleap"],
    #gleap-frame-container,
    .gleap-frame-container,
    .gleap-frame-container--modern-left {
      right: 20px !important;
      left: auto !important;
      bottom: 2.5rem !important;
    }
    
    /* Make Gleap container fill properly */
    #gleap-frame-container,
    .gleap-frame-container,
    div[class*="gleap-frame"],
    div[class*="gleap"][style*="position"] {
      width: 100% !important;
      height: 600px !important;
    }
    
    /* Make all inner elements and iframe fill the container */
    #gleap-frame-container > *,
    .gleap-frame-container > *,
    div[class*="gleap-frame"] > * {
      width: 100% !important;
      height: 100% !important;
    }
    
    #gleap-frame-container iframe,
    .gleap-frame-container iframe,
    div[class*="gleap"] iframe,
    div[class*="gleap-frame"] iframe,
    iframe[id*="gleap"],
    iframe[src*="gleap"],
    iframe[name*="gleap"] {
      width: 100% !important;
      height: 100% !important;
      min-width: 100% !important;
      min-height: 100% !important;
      border: none !important;
      display: block !important;
    }
  `;
  
  // Remove existing custom style if present
  const existingStyle = document.getElementById('gleap-custom-style');
  if (existingStyle) {
    existingStyle.remove();
  }
  
  document.head.appendChild(style);
};

// Apply styles after Gleap loads
setTimeout(styleGleapWidget, 500);

createRoot(document.getElementById("root")!).render(
  <PostHogProvider apiKey="phc_n5Q9iotYwJDXED8USKmBUgacG8g89qQedvmKBl7GzuL">
    <ClerkProvider publishableKey={publishableKey}>
      <App />
    </ClerkProvider>
  </PostHogProvider>,
);
